import type { ChatThread } from "types/ChatThread";
import useThreadsQuery from "services/dbApi/hooks/useThreadsQuery";
import { sortThreadsByDate } from "../utilities/sortThreadsByDate";

export default function useSearchThreadsQuery(q: string) {
  const lowerQ = q.trim().toLowerCase();

  return useThreadsQuery({
    select: (threads: ChatThread[]) => {
      const filtered = lowerQ
        ? threads.filter((t) => t.name.toLowerCase().includes(lowerQ))
        : threads;
      return sortThreadsByDate(filtered);
    },
  });
}
